import {
  CLIENT_TYPE,
  CLIENT_TYPE_HEADER,
} from '@upstart/harmony/lib/constants';
import { BackendService } from './BackendService';
import { Deal } from '../types/dealTypes';

const ONLINE_HEADERS = {
  [CLIENT_TYPE_HEADER]: CLIENT_TYPE.ONLINE,
};

export class DealService {
  static async createDeal(): Promise<any> {
    const newDeal = {
      applicant: { hasCoapplicant: 'no' },
      coapplicant: {},
      origin: 'Online',
      financeType: null,
      selectedOffer: null,
      testDriveDeliveryMethod: null,
      testDriveSelectedDateTime: null,
      testDriveStartedAt: null,
    };
    const response = await BackendService.post<any>('/deals', newDeal, {
      headers: ONLINE_HEADERS,
    });
    return response.data;
  }

  static async updateDeal(deal: Deal): Promise<any> {
    const response = await BackendService.put<any>(`/deals/${deal.id}`, deal, {
      headers: ONLINE_HEADERS,
    });
    return response.data;
  }
}
